import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';

const OwnerCount = observer(({ count }) => {
  const {
    dictionariesStore: { owner_count_types },
  } = useStores();

  if (!count) return null;
  return (
    <tr>
      <td className="pale">Владелец</td>
      <td>
        <span className="bold">{owner_count_types[count]}</span>
      </td>
    </tr>
  );
});

export default OwnerCount;
